module.exports = __webpack_public_path__ + "assets/Angle60Detailed.da7c7b029960d7c8bb52725778732097.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle60Detailed.png
// module id = 463
// module chunks = 0